document.addEventListener("DOMContentLoaded", function () {
  dynamicCreateArticleTopicsListAndAppendLinksToHeaders();

  document.querySelector(".article-topics-header").addEventListener("click", function () {
    toggleArticleTopicsList();
  });

  setReferencesContentHeightAndAddShowMoreButtonIfApplicable();
  handleExternalLinkTargets();
});

function dynamicCreateArticleTopicsListAndAppendLinksToHeaders() {
  const articleContent = document.querySelector("#article-content");
  const topicsList = document.querySelector(".article-topics-list");
  const headings = articleContent.querySelectorAll("h2, h3");

  if (headings.length === 0) {
    const list = document.querySelector(".article-topics");
    list.style.display = "none";
    return;
  }

  headings.forEach((h3, index) => {
    const text = h3.textContent.trim();
    if (!text) return;

    let id = h3.id;
    if (!id) {
      id = "heading-" + (index + 1);
      h3.id = id;
    }

    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = "#" + id;
    a.textContent = text;
    handleSmoothScrollToSection(a, id);
    li.appendChild(a);
    topicsList.appendChild(li);
  });
}

function handleSmoothScrollToSection(a, id) {
  a.addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.getElementById(id);
    if (target) {
      const y = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  });
}

function toggleArticleTopicsList() {
  const list = document.querySelector(".article-topics");
  const toggleBtn = document.querySelector(".article-topics-toggle");
  const isExpanded = list.classList.toggle("expanded");
  toggleBtn.textContent = isExpanded ? "−" : "+";

  var collapsedHeight = 71;
  var contentHeight = list.scrollHeight;

  list.style.height = (isExpanded ? contentHeight : collapsedHeight) + 'px';
}

function setReferencesContentHeightAndAddShowMoreButtonIfApplicable() {
  var container = document.querySelector('.article-references');
  if (!container) return;

  var list = container.querySelector('.article-references-list');
  var btn  = container.querySelector('.article-references-list-show-more-btn');

  var collapsedHeight = 140;
  var contentHeight = list.scrollHeight;

  if (contentHeight <= collapsedHeight + 4) {
    btn.style.display = 'none';
    list.style.maxHeight = contentHeight + 'px';
    container.classList.add('expanded');
    return;
  }

  container.classList.remove('expanded');
  list.style.maxHeight = collapsedHeight + 'px';
  btn.textContent = 'Show More';

  btn.addEventListener('click', function () {
    var expanded = container.classList.toggle('expanded');
    btn.textContent = expanded ? 'Show Less' : 'Show More';
    list.style.maxHeight = expanded ? (contentHeight + 'px') : (collapsedHeight + 'px');
  });
}

function handleExternalLinkTargets() {
  const blogLinks = document.querySelectorAll('#article-content a');
  const currentHostname = window.location.hostname;

  blogLinks.forEach((link) => {
    if (link.hostname && link.hostname !== currentHostname) {
      const currentTarget = link.getAttribute('target');
      if (currentTarget !== '_blank') {
        link.setAttribute('target', '_blank');
      }
    }
  });
}